import React, {
    useEffect,
    useState
} from "react";

import axios from "axios";

import {
    useNavigate
} from "react-router-dom";

import "./ContinueTraining.css";

import {
    Play,
    Clock,
    ArrowRight
} from "lucide-react";


const ContinueTraining = () => {

    const navigate =
        useNavigate();

    const email =
        localStorage.getItem(
            "user_email"
        );

    const [
        training,
        setTraining
    ] = useState(null);

    const [
        loading,
        setLoading
    ] = useState(true);


    /* =========================================
       LOAD TRAINING
    ========================================= */

    useEffect(() => {

        if (email) {

            loadTraining();

        }

    }, [email]);


    const loadTraining = async () => {

        try {

            const res =
                await axios.get(
                    `/api/dashboard/${email}`
                );


            if (
                res.data.history &&
                res.data.history.length > 0
            ) {

                setTraining({

                    ...res.data.history[0],

                    // ⭐ Resume always goes to Practice Modes
                    route:
                        "/ignite/arena/practice"

                });

            }

        }

        catch (err) {

            console.error(
                "Continue Training Error:",
                err
            );

        }

        finally {

            setLoading(false);

        }

    };


    /* =========================================
       LOADING
    ========================================= */

    if (loading) {

        return (

            <div className="continue-training-card">

                Loading...

            </div>

        );

    }


    /* =========================================
       NO TRAINING
    ========================================= */

    if (!training) {

        return (

            <div className="continue-training-card">

                <div className="continue-header">

                    <div>

                        <h2>
                            Resume Training
                        </h2>

                        <p>
                            Continue from where you stopped.
                        </p>

                    </div>

                    <Play size={30} />

                </div>


                <div
                    className="continue-body"
                >

                    <div
                        className="training-badge"
                    >

                        🎯

                    </div>


                    <div>

                        <h3>
                            No Training Yet
                        </h3>

                        <span>
                            Complete your first assessment.
                        </span>

                    </div>

                </div>

            </div>

        );

    }


    /* =========================================
       TRAINING AVAILABLE
    ========================================= */

    return (

        <div className="continue-training-card">


            {/* ================= HEADER ================= */}

            <div className="continue-header">

                <div>

                    <h2>
                        Resume Training
                    </h2>

                    <p>
                        Continue from where you stopped.
                    </p>

                </div>

                <Play size={30} />

            </div>


            {/* ================= BODY ================= */}

            <div className="continue-body">

                <div
                    className="training-badge"
                >

                    ⚡

                </div>


                <div>

                    <h3>
                        {training.testName}
                    </h3>

                    <span>
                        Last Score • {training.score}
                    </span>

                </div>

            </div>


            {/* ================= FOOTER ================= */}

            <div className="continue-footer">


                <div>

                    <Clock size={16} />

                    <span>

                        {
                            new Date(
                                training.date
                            ).toLocaleString(
                                "en-IN",
                                {
                                    dateStyle:
                                        "medium",

                                    timeStyle:
                                        "short"
                                }
                            )
                        }

                    </span>

                </div>


              


            </div>


        </div>

    );

};


export default ContinueTraining;